import { AAds } from './AdConfig'
import BannerAd from './BannerAd'

function AdsRoute() {
  return (
    <>
      {Object.values(AAds).map((ad) => (
        <BannerAd key={ad} AdUnitId={ad} />
      ))}
    </>
  )
}

export default AdsRoute
